import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/regular/star.svg'
import BaseIcon from '../../BaseIcon'

const Star = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 576 512" />
}

Star.propTypes = {
	className: PropTypes.string,
}

Star.defaultProps = {
	className: null,
}
export default Star
